export const styleRow = `
@media(max-width:767px){
    flex-direction:column;
    row-gap:15px;
}
`

export const styleInputWrapper = `
    width:35%;
    @media(max-width:767px){
        width:100%;
    }
`
